// @see https://github.com/mobxjs/mobx-state-tree
import { types } from 'mobx-state-tree'

const ModalsStore = types.model({
  name: types.optional(types.string, ''),
  redirect_path: types.optional(types.string, '')
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    setModal (name, redirect_path) {
      self.name = name
      self.redirect_path = redirect_path
    }
  })
)

export default ModalsStore



// WEBPACK FOOTER //
// ./src/stores/ModalsStore.js